import * as React from 'react';
import dashboardWrapper from '../..//wrappers/dashboard';
import { t } from '~/i18n';
import AlertTableContainer from '~/containers/Alerts/AlertTable';
import { Site } from '@watcherr/resources';

const AlertsPage = () => (
  <>
    <AlertTableContainer getSiteConfig={Site.getSiteConfiguration} />
  </>
);

export default dashboardWrapper(AlertsPage, t('menu.dashboard.alerts'));
